// BUILD-046 Owner direction of 2026-10-21 (cycle A, correction A): the quiet inline note shown above a list whose silent re-read (when the Phoenix day turned) failed.
//
// The list keeps the rows it had; this note says so, in plain words, with a Retry for THAT list only. While the person's Retry is in flight it reads "Refreshing ...". It is a
// status line, not an alert: nothing is lost, and nothing is blanked. It is drawn only while the controller holds a note for the list the tab shows; a successful refresh, a
// Retry that works, a reload of the list or a Caller change removes it. The words are listRefreshModel.ts's.
import { describeRefreshNote } from './listRefreshModel';
import type { RefreshNote } from './listRefreshModel';

export interface ListRefreshNoteProps {
  note: RefreshNote | undefined;
  /** The list's name in the note, for example "My tasks". */
  listLabel: string;
  onRetry: () => void;
}

export function ListRefreshNote({ note, listLabel, onRetry }: ListRefreshNoteProps) {
  const view = describeRefreshNote(note, listLabel);
  if (view === null) return null;
  if (view.kind === 'refreshing') {
    return (
      <p role="status" aria-live="polite" className="mb-2 rounded border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900" data-testid="list-refresh-note">
        {view.text}
      </p>
    );
  }
  return (
    <div role="status" aria-live="polite" className="mb-2 flex flex-wrap items-center justify-between gap-2 rounded border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900" data-testid="list-refresh-note">
      <div>
        <p className="font-medium">{view.headline}</p>
        <p className="mt-0.5">{view.detail}</p>
      </div>
      <button
        type="button"
        onClick={onRetry}
        aria-label={`Retry refreshing ${listLabel}`}
        className="rounded border border-amber-400 bg-white px-3 py-1 text-xs font-medium text-amber-900 hover:bg-amber-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-600"
      >
        Retry
      </button>
    </div>
  );
}
